/** Public hosts where password signup and password/passkey login are disabled. */
const SSO_ONLY_HOST_SLUGS = new Set(['culture-gouv']);

function hostSlug(hostname: string): string | null {
  const normalized = hostname.trim().toLowerCase().split(':')[0];
  if (!normalized) return null;
  const dot = normalized.indexOf('.');
  if (dot <= 0) return normalized;
  return normalized.slice(0, dot);
}

export function isSsoOnlyHostname(hostname: string): boolean {
  const slug = hostSlug(hostname);
  return Boolean(slug && SSO_ONLY_HOST_SLUGS.has(slug));
}
